export default {
  namespaced: true,
  risk: {
    title: "Avaliação de Risco",
    template: {
      title: " Modelo de Formulário| Modelos de Formulário",
      name: "Nome",
      question: "Pergunta | Perguntas",
      add_new_field: "Adicionar um Novo Campo",
      type_response: "Tipo de Resposta",
      field_name: "Nome do Campo",
      field_types: "Tipos de Campo",
      field_type_config: "Configuração do Tipo de Campo",
      options: "Opções",
      option_name: "Nome da Opção",
      add_option: "Adicionar uma Opção",
      added_options: "Opções Adicionadas",
      add_section: "Adicionar seção",
      new_section: "Nova seção",
      section_name: "Nome da seção",
      no_section: "Sem seção",
      add_field_here: "Adicionar pergunta aqui",
      drop_or_add_here: "Arraste ou adicione aqui",
      confirm_delete_section:
        "Excluir a seção? Suas perguntas serão movidas para 'Sem seção'.",
      confirm_delete_field: "Excluir esta pergunta?",
      visibility: "Visibilidade",
      condition: "Condicionar",
      previous_question: "Pergunta (anterior)...",
      match_any: "Corresponda alguma",
      match_all: "Correspondam todas",
      select_one_or_more: "Selecione uma ou mais opções (Ctrl/Cmd + clique).",
      select_option: "Selecione...",
      clear: "Limpar",
      no_conditions: "Sem condições: este campo é sempre visível.",
      error_invalid_conditions: "A pergunta referenciada não existe mais nesta seção.",
      error_invalid_order: "A pergunta referenciada deve ser anterior.",
      error_missing_value: "Selecione pelo menos uma opção para a condição.",
      placeholder_value: "Valor do Placeholder",
      placeholder_hint: "Ex: @DATA, @HORA, @ID",
      placeholder_available: "Disponíveis",
      placeholder_separator_hint: "Você pode adicionar múltiplos valores separados por vírgulas ou hífens",
      add_placeholder: "Adicionar Placeholder",
      added_placeholders: "Placeholders Adicionados",
      placeholder_already_exists: "Este placeholder já existe",

      // Placeholder values
      placeholder_date: "@DATA",
      placeholder_time: "@HORA",
      placeholder_datetime: "@DATA_HORA",
      placeholder_reference: "@REFERÊNCIA",
      placeholder_id: "@ID",
    },
    evaluation: {
      title: "Avaliação | Avaliações",
    },
    form_validations: {
      name: "O nome é obrigatório",
      type: "O tipo é obrigatório",
    },
    form: {
      title: "formulário de risco",
    },
    required: "Obrigatório",
    risk_percentage: "Porcentagem de Risco (%)",
    close: "Fechar",
    Apply: "Aplicar",
    comment: "Comentário",
    file: "Arquivos",
    select_form: "Selecione um formulário de avaliação de riscos",
    select_form_place_holder: "Selecione um formulário",
    selected_form: "Formulário selecionado",
    answer_form: "Responder formulário",
    new_evaluation: "Nova Avaliação",
    risk_evaluations_title: "Avaliação de Risco",
    confirm_delete: "Tem certeza que deseja excluir esta avaliação?",
    no_evaluations: "Nenhuma avaliação encontrada",
    download: "Baixar avaliação",
    evaluation_deleted: "Avaliação excluída",
    filters: {
      units: "Unidades",
      users: "Usuários",
      status: "Status",
      date_range: "Intervalo de Datas",
      start_date: "Data de Início",
      end_date: "Data de Fim",
      status_form: "Formulário de Status",
    },
    operational_procedures: "Procedimentos Operacionais",
    reference_number: "Número de Referência",
    title_notification: "Avaliação de Risco",
    status_notification: "Status",
    status_schedule: "Programado",
    status_in_progress: "Em Progresso",
    status_in_review: "Em Revisão",
    status_assigned: "Assigned",
    status_approved_cancelled: "Aprovado/Cancelado",
    status_rejected: "Rejeitado",
    status_approved: "Aprovado",
    status_canceled: "Cancelado",
    status_reassigned: "Reatribuído",
    remove_notification: "Remover",
    no_completed_evaluations: "Nenhuma avaliação completada",
    last_completed_result: "Último resultado completado",
    add_comment: "Adicionar comentário",
    review_comments_title: "Comentários de revisão",
    drop_or_add_here: "Arraste ou adicione aqui",
    user: "Usuário",
  },
  confirm_cancel: "Tem certeza de que deseja cancelar esta avaliação?",
  canceled: "Avaliação cancelada",
};
